import { DatePipe, DecimalPipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeItExtra from '@angular/common/locales/extra/it';
import localeKoExtra from '@angular/common/locales/extra/ko';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeTrExtra from '@angular/common/locales/extra/tr';
import localeZhExtra from '@angular/common/locales/extra/zh';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeKo from '@angular/common/locales/ko';
import localePl from '@angular/common/locales/pl';
import localeTr from '@angular/common/locales/tr';
import localeZh from '@angular/common/locales/zh';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdministrationModule } from '@components/administration/administration.module';
import { ConfigurationModule } from '@components/administration/organization/configuration/configuration.module';
import { DashboardModule } from '@components/dashboard/dashboard.module';
import { HeaderComponent } from '@components/header/header.component';
import { LegalNoticeModalComponent } from '@components/header/legal-notice/legal-notice-modal.component';
import {
  NotificationModalComponent
} from '@components/header/notification/notification-modal/notification-modal.component';
import { NotificationComponent } from '@components/header/notification/notification.component';
import { PagesModule } from '@components/pages/pages.module';
import { WidgetsConfigurationModule } from '@components/pages/widgets/widgets-configuration/widgets-configuration.module';
import { SidebarModule } from '@components/sidebar/sidebar.module';
import {
  SupportContactItemComponent
} from '@components/support/support-contact/support-contact-item/support-contact-item.component';
import { SupportContactComponent } from '@components/support/support-contact/support-contact.component';
import { SupportDocumentationComponent } from '@components/support/support-documentation/support-documentation.component';
import { UserModule } from '@components/user/user.module';
import { EnvironmentConfig } from '@environments/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { SharedModule } from '@shared/shared.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { AuthorizationGuardService } from 'src/app/shared/authorization-guard/authorization-guard.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalErrorInterceptor } from './shared/global-error-interceptor/global-error.interceptor';
import { provideHighcharts } from 'highcharts-angular';
import { CustomerTranslateLoader } from '@services/translation/customer-translate-loader.service';

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        SupportContactComponent,
        SupportDocumentationComponent,
        SupportContactItemComponent,
        LegalNoticeModalComponent,
        NotificationModalComponent,
        NotificationComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        RecaptchaV3Module,
        NgbModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomerTranslateLoader
            }
        }),
        AngularFireModule.initializeApp(EnvironmentConfig.firebase),
        AngularFireModule,
        AngularFireAuthModule,
        SharedModule,
        DashboardModule,
        UserModule,
        AdministrationModule,
        SidebarModule,
        PagesModule,
        GoogleMapsModule,
        WidgetsConfigurationModule,
        ConfigurationModule], providers: [
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: EnvironmentConfig.CaptchaSettings.captchaKey },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorInterceptor, multi: true },
        { provide: FIREBASE_OPTIONS, useValue: EnvironmentConfig.firebase },
        DatePipe,
        DecimalPipe,
        AuthorizationGuardService,
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
        provideHttpClient(withInterceptorsFromDi()),
        provideHighcharts()
    ] })
export class AppModule {
}

registerLocaleData(localeDe, 'de', localeDeExtra);
registerLocaleData(localeFr, 'fr', localeFrExtra);
registerLocaleData(localeEs, 'es', localeEsExtra);
registerLocaleData(localeIt, 'it', localeItExtra);
registerLocaleData(localeKo, 'ko-KR', localeKoExtra);
registerLocaleData(localePl, 'pl', localePlExtra);
registerLocaleData(localeTr, 'tr', localeTrExtra);
registerLocaleData(localeZh, 'zh_CN', localeZhExtra);

